module.exports = __webpack_public_path__ + "static/img/geloction2.90d3795.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/geloction2.png
// module id = Op65
// module chunks = 1